import { randomString } from "@/utils/common"

export const basicInfo = {
  name: "基本信息",
  tempId: randomString(10),
  emptyText: "未填写",
  fields: [
    {
      name: "任务模版",
      id: "taskType"
    },
    {
      name: "任务标题",
      id: "name"
    },
    {
      name: "负责人",
      id: "leader"
    },
    {
      name: "负责角色",
      id: "assigneeRole"
    },
    {
      name: "任务状态",
      id: "status"
    },
    {
      name: "开始时间",
      id: "startAt"
    },
    {
      name: "截止时间",
      id: "dueDate"
    },
    {
      name: "任务路径",
      id: "path"
    },
    {
      name: "父任务",
      id: "parentTask"
    },
    {
      name: "任务优先级",
      id: "priority"
    },
    {
      name: "任务附件",
      id: "attachments"
    },
    {
      name: "任务备注",
      id: "remark"
    }
  ]
}

export const systemInfo = {
  name: "系统信息",
  tempId: randomString(10),
  emptyText: "无",
  fields: [
    {
      name: "创建人",
      id: "creator"
    },
    {
      name: "创建时间",
      id: "createAt"
    },
    // {
    //   name: "最后修改人",
    //   id: "updateUser"
    // },
    // {
    //   name: "最后修改时间",
    //   id: "updateAt"
    // },
    {
      name: "完成人",
      id: "completeUser"
    },
    {
      name: "完成时间",
      id: "completeAt"
    },
    {
      name: "审批完成时间",
      id: "verifyAt"
    }
  ]
}
